/* eslint-disable */
/**
 * @author Leonel Martinez
 * @module C2C
 * @fileoverview `Vuex Cover-to-cover module`
 */
import { C2CService } from "@/services";
import { rootAction } from "../index";
import { MESSAGES } from "@/utils";

export const C2C = {
  namespaced: true,
  state: {
    currentC2C: null,
    C2CResponse: null,
  },
  actions: {
    /**
     * @description Loads a Cover-to-cover landing page based on the requested URL.
     * @param {object} request Url
     */
    GET_C2C: ({ commit, dispatch }, request) =>
      new Promise(resolve => {
        dispatch("spinner/TOGGLE_SPINNER", { active: true }, rootAction);
        C2CService.getC2C(request).then(
          c2c => {
            dispatch("spinner/TOGGLE_SPINNER", { active: false }, rootAction);
            commit("SET_C2C", c2c);
            resolve(c2c);
          },
          error => {
            dispatch("spinner/TOGGLE_SPINNER", { active: false }, rootAction);
            dispatch("snackbar/SHOW_SNACKBAR", MESSAGES.SERVER_ERROR, { root: true });
            reject(error);
          }
        );
      }),
    SET_C2C_URL({ commit }, url) {
      commit("SET_C2C_URL", url);
    }
  },
  mutations: {
    SET_C2C(state, payload) {
      state.currentC2C = payload 
    },
    SET_C2C_URL(state) {
      state.currentC2C = null;
    }
  }
};
